(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme-styles"] && !Shopify.designMode) return;
  try {
    (() => {
    const supported = 'IntersectionObserver' in window;

    const showAll = (root) => {
      root.querySelectorAll('.reveal').forEach((el) => el.classList.add('in-view'));
    };

    if (!supported) {
      showAll(document);
      document.addEventListener('shopify:section:load', (e) => showAll(e.target));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    const observe = (root) => {
      root.querySelectorAll('.reveal:not(.in-view)').forEach((el) => observer.observe(el));
    };

    observe(document);

    // The theme editor re-renders a section's markup whenever a setting changes.
    // Those fresh nodes were never observed, so without this they would stay at
    // opacity 0 and the section would look empty.
    document.addEventListener('shopify:section:load', (e) => observe(e.target));
    document.addEventListener('shopify:section:reorder', () => observe(document));
    document.addEventListener('shopify:block:select', (e) => showAll(e.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
